
<template>
    <div class="row">
        <div class="col-sm-6 col-lg-6 col-xl-4 box-col-33" v-for="item in friends" :key="item">
            <div class="card custom-card">
                <div class="card-header"><img class="img-fluid" :src="getImgUrl(item.img)" alt=""></div>
                <div class="card-profile"><img class="rounded-circle" :src="getImgUrl(item.img1)" alt=""></div>
                <ul class="card-social">
                    <li><a href="https://www.facebook.com" target="_blank"><i class="fa fa-facebook"></i></a></li>
                    <li><a href="https://www.google.com" target="_blank"><i class="fa fa-google-plus"></i></a></li>
                    <li><a href="https://www.twitter.com" target="_blank"><i class="fa fa-twitter"></i></a></li>
                    <li><a href="https://www.instagram.com" target="_blank"><i class="fa fa-instagram"></i></a></li>
                    <li><a href="https://www.rss.com" target="_blank"><i class="fa fa-rss"></i></a></li>
                </ul>
                <div class="text-center profile-details"><router-link to="/users/profile">
                        <h2>{{ item.name }}</h2>
                        <h6>{{ item.title }}</h6>
                    </router-link></div>
                <div class="card-footer row">
                    <div class="col-4 col-sm-4">
                        <h6>Follower</h6>
                        <h3 class="counter">{{ item.follower }}</h3>
                    </div>
                    <div class="col-4 col-sm-4">
                        <h6>Following</h6>
                        <h3><span class="counter">{{ item.following }}</span>K</h3>
                    </div>
                    <div class="col-4 col-sm-4">
                        <h6>Total Post</h6>
                        <h3><span class="counter">{{ item.total }}</span>M</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import friend from '@/data/usercard.json'
export default {
    data() {
        return {
            friends: friend.data
        }
    },
    methods: {
        getImgUrl(path) {
            return require('@/assets/images/' + path)
        }
    }

}
</script>
    